import { render, staticRenderFns } from "./AgoraToolbar.vue?vue&type=template&id=3a1c10ea&"
import script from "./AgoraToolbar.vue?vue&type=script&lang=js&"
export * from "./AgoraToolbar.vue?vue&type=script&lang=js&"
import style0 from "./AgoraToolbar.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports